(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/helpers/utils.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/helpers/utils.js'); 
(function(Backbone, _, svs) {
  svs.tipset.utils = svs.tipset.utils || {};

  svs.tipset.utils.convertBoardToItsData = function(board) {
    var signArr = [
      { itsId: '1', wagerId: 1 },
      { itsId: '2', wagerId: 4 },
      { itsId: 'X', wagerId: 2 },
      { itsId: '12', wagerId: 5 },
      { itsId: '1X', wagerId: 3 },
      { itsId: 'X2', wagerId: 6 },
      { itsId: '1X2', wagerId: 7 },
      { itsId: '12M', wagerId: 13 },
      { itsId: 'X2M', wagerId: 14 },
      { itsId: '1XM', wagerId: 11 },
      { itsId: '1X2M', wagerId: 15 },
      { itsId: '0', wagerId: 0 }
    ];
    var itsBoard = [];

    for (var i = 0; i < board.length; i++) {
      itsBoard[i] = _.findWhere(signArr, { wagerId: board[i] }).itsId;
    }
    return itsBoard;
  };

  svs.tipset.utils.convertBoardFromITSData = function(itsBoard) {
    var signArr = [
      { itsId: '1', wagerId: 1 },
      { itsId: '2', wagerId: 4 },
      { itsId: 'X', wagerId: 2 },
      { itsId: '12', wagerId: 5 },
      { itsId: '1X', wagerId: 3 },
      { itsId: 'X2', wagerId: 6 },
      { itsId: '1X2', wagerId: 7 },
      { itsId: '12M', wagerId: 13 },
      { itsId: 'X2M', wagerId: 14 },
      { itsId: '1XM', wagerId: 11 },
      { itsId: '1X2M', wagerId: 15 },
      { itsId: '0', wagerId: 0 }
    ];
    var board = [];
    _.each(itsBoard, function(value, index) {
      board[index] = _.findWhere(signArr, { itsId: value }).wagerId;
    });
    return board;
  };

  svs.tipset.utils.cleanString = function(text) {
    var normalizedString = text.replace(/\s+/g, ' ');
    return normalizedString.trim();
  };
})(Backbone, _, svs);

 })(window);